import { Box, Button, Container, makeStyles } from '@material-ui/core'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import ProductApi from 'src/api/product'
import AppContext from 'src/AppContext'
import CustomDatatable from 'src/components/CustomDatatable'
import Page from 'src/components/Page'
import Toolbar from 'src/components/Toolbar'
import { Types } from 'src/reducers/AppReducer'
import { IProduct } from 'src/types/Product'
import tableColumns from './tableColumns'

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.default,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
}))

const Product = () => {
  const classes = useStyles()
  const [storeList, setProductList] = React.useState<IProduct[]>([])
  const { dispatch } = React.useContext(AppContext)
  const navigate = useNavigate()

  React.useEffect(() => {
    dispatch({ type: Types.Loading, payload: { loading: true } })
    ProductApi.get()
      .then((data: IProduct[]) => {
        console.log(data)
        setProductList(data)
      })
      .finally(() => {
        dispatch({ type: Types.Loading, payload: { loading: false } })
      })
  }, [dispatch, setProductList])

  const handleClick = (id: string) => navigate(id)
  const handleAdd = () => navigate('new')

  return (
    <Page className={classes.root} title="Product">
      <Container maxWidth={false}>
        <Toolbar
          title="Products"
          buttons={
            <Box display="flex" justifyContent="flex-end">
              <Button color="primary" variant="contained" onClick={handleAdd}>
                Create Product
              </Button>
            </Box>
          }
        />
        <Box mt={3}>
          <CustomDatatable list={storeList || []} onClick={handleClick} tableColumns={tableColumns} download={false} />
        </Box>
      </Container>
    </Page>
  )
}

export default Product
